module.exports = __webpack_public_path__ + "static/img/point-color@w.1716e17.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/partecs/point-color@w.png
// module id = JM8c
// module chunks = 0